import { CREATE_NEW_RESPONSE } from '../actions/responseMetadata';
import { LOAD_RESPONSE_DATA, TOGGLE_QUESTION_FLAGGED, SAVE_ANSWER, SAVE_ANSWER_NOTE } from '../actions/response';
import { FINISHED_RESPONSE_PUSH, START_RESPONSE_PUSH } from '../actions/sync';
import { SORT_OPTIONS, SAVE_NOTE, DELETE_NOTE } from '../actions/userEdits';
import { SAVE_TR_FOR_RESPONSE } from '../actions/translation';

const responseMetadata = (state = {id: null, pushing: false}, action) => {
  switch(action.type) {
    case CREATE_NEW_RESPONSE:
      return {
        ...state,
        createdAt: new Date().getTime(),
        editedAt: new Date().getTime(),
        created: false,
        lastSynced: 0,
        name: action.name,
        email: action.email,
        reviewStage: 0
      }
    case START_RESPONSE_PUSH:
      return {
        ...state,
        pushing: true
      }
    case FINISHED_RESPONSE_PUSH:
      return {
        ...state,
        created: state.created || !action.error,
        pushing: false,
        lastSynced: action.error ? state.lastSynced : new Date().getTime()
      }
    case TOGGLE_QUESTION_FLAGGED:
    case SAVE_ANSWER:
    case SAVE_ANSWER_NOTE:
    case SORT_OPTIONS:
    case SAVE_NOTE:
    case DELETE_NOTE:
    case SAVE_TR_FOR_RESPONSE:
      return {
        ...state,
        editedAt: new Date().getTime()
      }
    case LOAD_RESPONSE_DATA:
      return {
        ...state,
        ...action.payload.metadata,
        created: true
      }
    default:
      return state;
  }
}

export default responseMetadata;
